import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./afla-module.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./afla-module.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { AflaModuleStatus } from "../shared/module-status.model";
import { Router } from "@angular/router";
import { AppControllerService } from "../../../app-controller.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { UserInformationService } from "src/app/shared/services/user/user-information.service";
let AflaModuleComponent = class AflaModuleComponent {
    router;
    appControllerService;
    userInformationService;
    getModule;
    set module(model) {
        this.getModule = model;
    }
    get module() {
        return this.getModule;
    }
    searchedName;
    set overdueCount(overdueCount) {
        this.updateOverdueCounts(overdueCount);
    }
    set fiveDayToGo(fiveDayToGo) {
        this.updateFiveDayToGo(fiveDayToGo);
    }
    set statusCount(statusCount) {
        this.updateStatusCount(statusCount);
    }
    moduleStatuses;
    phases;
    constructor(router, appControllerService, userInformationService) {
        this.router = router;
        this.appControllerService = appControllerService;
        this.userInformationService = userInformationService;
    }
    ngOnInit() {
    }
    trackModuleStatus(index, item) {
        return item;
    }
    openApplications() {
        this.appControllerService.setSelectedModule(this.module.id);
        this.router.navigate([
            AppRoutingConstants.ROUTE_SEPERATOR +
                this.appControllerService.selectedModuleID +
                AppRoutingConstants.ROUTE_SEPERATOR +
                ApplicationsRoutingConstants.APPLICATIONS_ROUTE,
        ]);
    }
    updateStatusCount(statusCount) {
        statusCount?.forEach((elm) => {
            if (this.phases)
                this.phases.push({ name: elm.status, value: elm.count });
            else if (!this.phases && elm.count) {
                this.phases = [{ name: elm.status, value: elm.count }];
            }
        });
    }
    updateFiveDayToGo(fiveDayToGo) {
        if (this.moduleStatuses) {
            this.moduleStatuses.push({
                status: AflaModuleStatus.Remaining,
                value: fiveDayToGo,
            });
        }
        else if (!this.phases && fiveDayToGo) {
            this.moduleStatuses = [
                {
                    status: AflaModuleStatus.Remaining,
                    value: fiveDayToGo,
                },
            ];
        }
    }
    updateOverdueCounts(overdueCount) {
        if (this.moduleStatuses) {
            this.moduleStatuses.push({
                status: AflaModuleStatus.Overdue,
                value: overdueCount,
            });
        }
        else if (!this.phases && overdueCount) {
            this.moduleStatuses = [
                {
                    status: AflaModuleStatus.Overdue,
                    value: overdueCount,
                },
            ];
        }
    }
    static ctorParameters = () => [
        { type: Router },
        { type: AppControllerService },
        { type: UserInformationService }
    ];
    static propDecorators = {
        module: [{ type: Input }],
        searchedName: [{ type: Input }],
        overdueCount: [{ type: Input }],
        fiveDayToGo: [{ type: Input }],
        statusCount: [{ type: Input }]
    };
};
AflaModuleComponent = __decorate([
    Component({
        selector: "app-afla-module",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AflaModuleComponent);
export { AflaModuleComponent };
